import React, { Fragment, Suspense } from "react";
import { Route, Routes as Switch } from "react-router-dom";
import NoComponentFound from "../views/NoComponentFound";
import PATHS, { authenticationFlowPaths } from "../paths";
import RenderableView from "./RenderableView";
import withErrorBoundary from "../../Common/hocs/withErrorBoundary";
import AuthenticationComponent from "./AuthenticationComponent";
import LoadingSpinner from "../../Common/components/LoadingSpinner";

function Routes() {
  let RoutesToRender = PATHS.map((pathInformation, index) => (
    <Route
      key={`route${encodeURIComponent(pathInformation.title)}#${index}`}
      path={pathInformation.path}
      element={<RenderableView {...pathInformation} />}
    />
  ));

  return (
    <Fragment>
      <Suspense fallback={<LoadingSpinner />}>
        <Switch>
          {authenticationFlowPaths.map(({ path, ...rest }, index) => (
            <Route
              key={`route${encodeURIComponent(path)}#${index}`}
              path={path}
              element={<AuthenticationComponent {...rest} />}
            />
          ))}
          {RoutesToRender}
          <Route element={<NoComponentFound />} />
        </Switch>
      </Suspense>
    </Fragment>
  );
}

/**
 * 
 * Authenticated
 * <Component1 />
 * <Component2 />
 */

export default withErrorBoundary(Routes);
